import { getRequest } from '../services/requestHandler';
import { TourBagMstrPayload } from '../models';

export const getSyncRpcTourBagMstrByPlayerId = async (playerId: number) => {
  const url = `tourbag/syncRpcTourBagMstrByPlayerId?playerid=${playerId}`;
  const response = await getRequest<TourBagMstrPayload>('syncRpcTourBagMstrByPlayerId', url);
  return response;
};
